export default function initTeam() {

  const popupLinks = Array.from(document.getElementsByClassName("team-member-more-link"))

  if (popupLinks.length > 0) {
  //   const closeButton = document.querySelector(".close-popup")
    const openButton = document.querySelectorAll(".team-member-more-link")
    const closeButton = document.querySelectorAll(".member-popup-close")
    const popups = document.querySelectorAll('.member-popup')
    function openPopup(item) {
      popups.forEach((popup) =>
          popup.style.display = "none"
      )
      let popupId = item.getAttribute('data-content')
      document.querySelector('#' + popupId).style.display = 'block'
    }
    function closePopup() {
      popups.forEach((popup) =>
          popup.style.display = "none"
      )
    }
    if(openButton.length > 0) {
      window.addEventListener(
          "load",
          openButton.forEach((item) =>
          item.onclick = function() {
          openPopup(item)
          }

          )
      )
      if(closeButton.length > 0) {
          window.addEventListener(
              "load",
              closeButton.forEach((item) =>
                  item.onclick = function() {
                      closePopup()
                  }
              )
          )
      }
      else {
          console.error('Teams: failed to load closePopup eventListener')
      }
    }
  }
}